import { render, staticRenderFns } from "./TablePuntosVenta.vue?vue&type=template&id=0291f3ae"
import script from "./TablePuntosVenta.vue?vue&type=script&lang=js"
export * from "./TablePuntosVenta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports